const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validateDevelopmentServiceForm = (inputValues, setInputErrors) => {
    let errors = {};
    let hasError = false;

    const KEYS = {
        name: "Name",
        email: "Email",
        phone: "Phone",
        service: "Service",
        message: "Message",
    }

    Object.keys(inputValues).forEach((key) => {
        if (!inputValues[key].trim()) {
            errors[key] = `${KEYS[key]} is required`;
            hasError = true;
        }
    });

    if (inputValues.email && !emailRegex.test(inputValues.email)) {
        errors.email = "Invalid email format";
        hasError = true;
    }

    setInputErrors(Object.keys(errors).length > 0 ? errors : {});
    return Object.keys(errors).length > 0;

}

export { validateDevelopmentServiceForm };